import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CredentialsService } from '@/features/auth/data-access/credentials.service';
import { ErrorUtils } from '@/core/utils/error.utils';

export const NOT_TOAST_ERROR = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
    const credentialsService = inject(CredentialsService);
    const messageService = inject(MessageService);

    return next(request).pipe(
        catchError((err) => {
            if (err?.status === 401 || !credentialsService.isAuthenticated()) {
                credentialsService.logout();
            }

            if (!request.context.get(NOT_TOAST_ERROR)) {
                messageService.add({
                    severity: 'error',
                    summary: 'Api Error',
                    detail: ErrorUtils.finestError(err),
                    life: 10000
                });
            }

            return throwError(() => err);
        })
    );
};
